import React, { useState } from 'react';
import { CgKey } from 'react-icons/cg';
import { FaCircle } from 'react-icons/fa';
import classesGlobal from '../../assets/Global.module.css';
import classesLoad from './Load.module.css';

const ColorLegend = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const idColumnItems = [
    { className: classesLoad.needsLoadInfo, text: 'Needs Load Information' },
    { className: classesLoad.readyToLoad, text: 'Ready to Load' },
    { className: classesLoad.readyToLoad, text: 'Over The Road' },
    { className: classesLoad.delivered, text: 'Delivered' },
    { className: classesLoad.needsAttention, text: 'Needs Attention' },
  ];

  const driverColumnItems = [
    { className: classesLoad.noDriver, text: 'No Driver' },
    { className: classesLoad.needsCall, text: 'Needs Check Call' },
    { className: classesLoad.checkCall, text: 'Check Call Completed' },
    { className: classesLoad.dispatched, text: 'Dispatched' },
    { className: classesLoad.issue, text: 'Issue' },
    // we currently do not have night watch implemented
    // { className: classesLoad.nightWatch, text: 'Night Watch' },
  ];

  const LegendItem = ({ className, text }) => (
    <span>
      <FaCircle className={className} />
      {text}
    </span>
  );

  const LegendSection = ({ title, items }) => (
    <div>
      <h6>{title}</h6>
      {items.map(item => (
        <LegendItem
          key={item.text}
          className={item.className}
          text={item.text}
        />
      ))}
    </div>
  );

  return (
    <div className={classesGlobal.dropdown}>
      <button onClick={() => setIsOpen(prev => !prev)} title="Color Legend">
        <CgKey />
      </button>
      {isOpen && (
        <div className={classesLoad.colorLegend}>
          <h4>Status Colors</h4>
          <LegendSection title="# Column" items={idColumnItems} />
          <LegendSection title="Driver Column" items={driverColumnItems} />
        </div>
      )}
    </div>
  );
};

export default ColorLegend;
